import dateService from '../services/util/dateService'
//import loggingService from '../services/util/loggingService'
import _ from 'lodash/lodash.min.js'

//var serviceName = 'scantoolMediaService'
var path = '/Scantool/'
//var isDebug = false

function list (http, investigationId) {
    return http.get(path + 'ListByInvestigationId?investigationId=' + investigationId).then(response => {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
        })
        return response
    })
}

function listByMediaTypeId (http, investigationId, mediaTypeId) {
    return http.get(path + `ListByInvestigationIdMediaTypeId?investigationId=${investigationId}&mediaTypeId=${mediaTypeId}`).then(response => {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
        })
        return response
    })
}

function removeByScantoolMediaId (http, scantoolMediaId) {
    return http.delete(path + `RemoveByScantoolMediaId?scantoolMediaId=${scantoolMediaId}`)
}

function get (http, scantoolMediaId) {
    return http.get(path + 'Get?scantoolMediaId=' + scantoolMediaId, { responseType: 'arraybuffer' })
}

export default {
    get: get,
    list: list,
    listByMediaTypeId: listByMediaTypeId,
    removeByScantoolMediaId: removeByScantoolMediaId
}



// WEBPACK FOOTER //
// ./src/services/scantoolMediaService.js